import { ImageSizeQueryParams } from 'api/KioskApi/entries/shared/queryParams';

export const LIMITED_IMAGE_SIZES: Record<string, ImageSizeQueryParams> = {
  EREGCARDLOGO: {
    height: 100,
  },
};
